import { useEffect } from 'react';

import { useProjectActions } from 'src/store/project';

export const useClearProjectGenerationInputsOnUnmount = () => {
  const projectActions = useProjectActions();

  useEffect(() => {
    return () => {
      projectActions.clearTovInputs();
      projectActions.clearImageAspectRatio();
      projectActions.clearImageOverlayProperties();
    };
  }, [projectActions]);
};
